import { useState } from "react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// Strict dry-run: shows exactly what would be sent/created with a sample contact and the real-run gates. Nothing is queued or created.
export function AutomationTest({ tid, akey }) {
  const api = useApi();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("Mario Rossi");
  const [email, setEmail] = useState("");
  const [r, setR] = useState(null);
  const run = async () => {
    try { const { data } = await api.post(`/t/${tid}/automations/${akey}/test`, { sample_name: name, ...(email ? { sample_email: email } : {}) }); setR(data); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!open) return <Button size="sm" variant="outline" onClick={() => setOpen(true)} data-testid={`automation-test-open-${akey}`}>Prova senza inviare</Button>;
  return (
    <div className="space-y-2 rounded-md border border-sky-200 bg-sky-50 p-3" data-testid={`automation-test-${akey}`}>
      <p className="text-xs text-sky-900">Modalità prova: nessuna email, attività o addebito reale. Vedi solo l'anteprima.</p>
      <div className="flex flex-wrap gap-2">
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome di prova" className="h-9 w-44 bg-white" data-testid={`automation-test-name-${akey}`} />
        <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email di prova (facoltativa)" className="h-9 w-56 bg-white" data-testid={`automation-test-email-${akey}`} />
        <Button size="sm" onClick={run} data-testid={`automation-test-run-${akey}`}>Mostra anteprima</Button>
      </div>
      {r && <div className="space-y-2 text-xs" data-testid={`automation-test-result-${akey}`}>
        {r.preview.map((p, i) => <div key={i} className="rounded border border-slate-200 bg-white p-2"><p className="font-medium text-slate-800">{p.type === "task" ? "Attività: " : p.type === "email" ? "Email: " : ""}{p.subject}</p><pre className="whitespace-pre-wrap font-sans text-slate-600">{p.text}</pre></div>)}
        <ul className="space-y-0.5" data-testid={`automation-test-checks-${akey}`}>{r.real_run_checks.map((c) => <li key={c.label}>{c.ok ? "✓" : "✗"} {c.label}{c.detail ? ` (${c.detail})` : ""}</li>)}</ul>
        <p className="font-medium text-slate-700" data-testid={`automation-test-verdict-${akey}`}>{r.would_run_now ? "Con le impostazioni attuali partirebbe davvero." : "Con le impostazioni attuali NON partirebbe nulla di reale."} {r.effects}.</p>
      </div>}
    </div>);
}
